function y(t, e, b, d, l) {
  let s, f;
  if (!t || !e)
    return {
      pos: "center",
      corner: void 0
    };
  const i = 14, n = 2, m = t.top + t.height / 2, v = t.left + t.width / 2, o = {
    top: t.top - e.height - i,
    bottom: d - t.bottom - e.height - i,
    left: t.left - e.width - i,
    right: b - t.right - e.width - i
  }, r = {
    left: v - e.width / 2 - n <= 0,
    right: v + e.width / 2 + n >= b,
    top: m - e.height / 2 - n <= 0,
    bottom: m + e.height / 2 + n >= d
  }, w = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
  }[l], a = Object.keys(o).filter((h) => o[h] > 0), j = Object.keys(o).sort((h, c) => o[h] > o[c] ? -1 : o[h] < o[c] ? 1 : 0);
  return o[l] > 0 ? s = l : o[w] > 0 ? s = w : a.length ? [s] = a : [s] = j, s === "bottom" || s === "top" ? r.left ? f = "left" : r.right && (f = "right") : r.top ? f = "top" : r.bottom && (f = "bottom"), {
    pos: s,
    corner: f
  };
}
export {
  y as default
};
